import { useCallback, useEffect, useMemo, useState } from "react";

import AppLinkButton from "../../../commons/buttons/AppLinkButton";
import AppLoading from "../../../commons/AppLoading";
import CompanyAPI from "../../company/CompanyAPI";
import CustomCard from "../../../commons/cards/Card";
import HallAppCenterContainer from "../../../commons/containers/HallAppCenterContainer";
import HallAppContainer from "../../../commons/containers/HallAppContainer";
import HallAppToast from "../../../commons/HallAppToast";
import ModalCompanyForm from "../../company/components/ModalCompanyForm";
import UserService from "../../../auth/UserService";

const service = new UserService();
const companyAPI = new CompanyAPI();

function HomeFirstAccess({ updateFirstAccess }) {
  const [userLogged, setUserLogged] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // memoize email to avoid null checks in JSX
  const userEmail = useMemo(() => userLogged?.email ?? "", [userLogged]);

  const checkUser = useCallback(() => {
    setUserLogged(service.getUserData());
  }, []);

  useEffect(() => {
    checkUser();
  }, [checkUser]);

  const updateMe = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await companyAPI.findAllMe();
      const companies = response?.data ?? [];

      if (companies.length > 0) {
        const first = companies[0];
        companyAPI.setCompanyManagment(first);
        companyAPI.setCompaniesLocalStorage(companies);
        checkUser();
        updateFirstAccess?.();
        HallAppToast.success();
      } else {
        HallAppToast.info?.("Nenhuma empresa encontrada para este usuário.");
      }
    } catch (_) {
      HallAppToast.genericError();
    } finally {
      setIsLoading(false);
    }
  }, [checkUser, updateFirstAccess]);

  return (
    <HallAppContainer>
      <div>
        <CustomCard>
          <p className="hallapp-title">Sou proprietário(a)</p>
          <p className="hallapp-subtitle" style={{ fontSize: 16 }}>
            Crie seu estabelecimento e convide sua equipe.
          </p>
          <ModalCompanyForm updateFirstAccess={updateFirstAccess} />
        </CustomCard>
      </div>

      <div style={{ marginTop: 24 }}>
        <CustomCard>
          <p className="hallapp-title">Sou funcionário(a)</p>
          <p className="hallapp-subtitle" style={{ fontSize: 16 }}>
            Peça para o administrador adicionar o seu e‑mail
            {" "}
            <span style={{ fontWeight: 600 }}>{userEmail}</span>
            {" "}
            no cadastro de funcionários. Depois, toque em Atualizar ou faça login novamente.
          </p>

          {isLoading ? (
            <HallAppCenterContainer>
              <AppLoading />
            </HallAppCenterContainer>
          ) : (
            <AppLinkButton onClick={updateMe} width="100%" name="Atualizar" />
          )}
        </CustomCard>
      </div>
    </HallAppContainer>
  );
}

export default HomeFirstAccess;